package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Brunei Flag (20x15dp)
 *
 * - ISO Alpha-2: BN
 * - ISO Alpha-3: BRN
 * - ISO Numeric: 096
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Brunei: ImageVector by lazy {
    ImageVector.Builder(
        name = "Brunei:BN:BRN:096:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD221)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF313131))) {
                moveTo(-1.917f, 6.635f)
                lineTo(-0.662f, 3.773f)
                lineTo(21.105f, 13.318f)
                lineTo(19.85f, 16.18f)
                lineTo(-1.917f, 6.635f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFAF9F9))) {
                moveTo(-1.886f, 3.481f)
                lineTo(-0.631f, 0.619f)
                lineTo(22.218f, 10.633f)
                lineTo(20.963f, 13.496f)
                lineTo(-1.886f, 3.481f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.582f, 7.748f)
                curveTo(3.695f, 6.66f, 3.843f, 5.924f, 3.843f, 5.924f)
                curveTo(3.843f, 5.924f, 4.751f, 5.958f, 4.741f, 6.543f)
                curveTo(4.741f, 6.79f, 5.066f, 7.024f, 5.346f, 7.226f)
                curveTo(5.559f, 7.378f, 5.745f, 7.512f, 5.745f, 7.619f)
                curveTo(5.745f, 7.868f, 5.932f, 10.375f, 5.932f, 10.375f)
                curveTo(5.932f, 10.375f, 5.801f, 10.604f, 5.175f, 10.604f)
                curveTo(4.549f, 10.604f, 4.582f, 10.243f, 4.582f, 10.243f)
                curveTo(4.962f, 9.777f, 4.582f, 7.748f, 4.582f, 7.748f)
                close()
                moveTo(15.418f, 7.748f)
                curveTo(16.305f, 6.66f, 16.157f, 5.924f, 16.157f, 5.924f)
                curveTo(16.157f, 5.924f, 15.25f, 5.958f, 15.26f, 6.543f)
                curveTo(15.26f, 6.79f, 14.934f, 7.024f, 14.654f, 7.226f)
                curveTo(14.442f, 7.378f, 14.255f, 7.512f, 14.255f, 7.619f)
                curveTo(14.255f, 7.868f, 14.068f, 10.375f, 14.068f, 10.375f)
                curveTo(14.068f, 10.375f, 14.199f, 10.604f, 14.825f, 10.604f)
                curveTo(15.452f, 10.604f, 15.418f, 10.243f, 15.418f, 10.243f)
                curveTo(15.039f, 9.777f, 15.418f, 7.748f, 15.418f, 7.748f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.037f, 1.797f)
                lineTo(10.742f, 2.299f)
                lineTo(10.28f, 2.423f)
                lineTo(10.742f, 2.822f)
                lineTo(10.167f, 2.676f)
                verticalLineTo(3.079f)
                horizontalLineTo(10.742f)
                lineTo(10.934f, 4.024f)
                lineTo(10.711f, 3.866f)
                lineTo(10.489f, 4.024f)
                lineTo(10.267f, 3.866f)
                lineTo(10.044f, 4.024f)
                lineTo(9.815f, 3.866f)
                lineTo(9.586f, 4.024f)
                lineTo(9.357f, 3.866f)
                lineTo(9.128f, 4.024f)
                lineTo(9.417f, 3.079f)
                horizontalLineTo(9.948f)
                verticalLineTo(1.797f)
                horizontalLineTo(10.037f)
                close()
                moveTo(13.178f, 4.97f)
                curveTo(13.178f, 4.97f, 12.964f, 5.159f, 12.503f, 4.97f)
                curveTo(12.349f, 4.906f, 12.181f, 4.795f, 12.005f, 4.68f)
                curveTo(11.654f, 4.449f, 11.275f, 4.2f, 10.925f, 4.269f)
                curveTo(10.401f, 4.373f, 10.168f, 4.623f, 10.168f, 4.623f)
                verticalLineTo(4.047f)
                horizontalLineTo(10.104f)
                horizontalLineTo(10.006f)
                horizontalLineTo(9.942f)
                verticalLineTo(4.623f)
                curveTo(9.942f, 4.623f, 9.709f, 4.373f, 9.185f, 4.269f)
                curveTo(8.836f, 4.2f, 8.456f, 4.449f, 8.105f, 4.68f)
                curveTo(7.93f, 4.795f, 7.761f, 4.906f, 7.607f, 4.97f)
                curveTo(7.147f, 5.159f, 6.932f, 4.97f, 6.932f, 4.97f)
                curveTo(6.932f, 4.97f, 6.932f, 5.13f, 7.274f, 5.378f)
                curveTo(7.423f, 5.485f, 7.593f, 5.477f, 7.737f, 5.434f)
                curveTo(7.63f, 5.515f, 7.578f, 5.61f, 7.749f, 5.686f)
                curveTo(8.103f, 5.844f, 8.685f, 5.429f, 8.748f, 5.382f)
                curveTo(8.677f, 5.435f, 7.974f, 5.963f, 8.296f, 5.963f)
                curveTo(8.635f, 5.963f, 9.185f, 5.519f, 9.185f, 5.519f)
                curveTo(9.185f, 5.519f, 8.518f, 6.159f, 8.877f, 6.258f)
                curveTo(9.105f, 6.322f, 9.378f, 5.989f, 9.506f, 5.792f)
                curveTo(9.51f, 5.834f, 9.548f, 5.859f, 9.59f, 5.887f)
                curveTo(9.644f, 5.923f, 9.703f, 5.963f, 9.703f, 6.045f)
                curveTo(9.703f, 6.151f, 9.73f, 6.169f, 9.753f, 6.185f)
                curveTo(9.771f, 6.197f, 9.786f, 6.208f, 9.786f, 6.258f)
                verticalLineTo(6.404f)
                lineTo(9.703f, 6.526f)
                curveTo(9.703f, 6.526f, 9.703f, 6.717f, 9.786f, 6.868f)
                curveTo(9.849f, 6.983f, 9.817f, 7.079f, 9.761f, 7.245f)
                curveTo(9.744f, 7.298f, 9.724f, 7.358f, 9.703f, 7.428f)
                curveTo(9.62f, 7.716f, 9.786f, 8.208f, 9.786f, 8.208f)
                horizontalLineTo(9.703f)
                curveTo(9.703f, 8.208f, 9.786f, 8.269f, 9.786f, 8.511f)
                curveTo(9.786f, 8.709f, 9.731f, 8.821f, 9.627f, 9.033f)
                curveTo(9.604f, 9.081f, 9.577f, 9.135f, 9.549f, 9.196f)
                curveTo(9.394f, 9.524f, 9.703f, 9.941f, 9.703f, 9.941f)
                curveTo(9.703f, 9.941f, 9.185f, 9.713f, 9.289f, 9.941f)
                curveTo(9.369f, 10.116f, 9.807f, 10.286f, 10.006f, 10.355f)
                verticalLineTo(10.388f)
                curveTo(10.006f, 10.388f, 10.024f, 10.382f, 10.055f, 10.372f)
                curveTo(10.086f, 10.382f, 10.104f, 10.388f, 10.104f, 10.388f)
                verticalLineTo(10.355f)
                curveTo(10.304f, 10.286f, 10.742f, 10.116f, 10.821f, 9.941f)
                curveTo(10.925f, 9.713f, 10.407f, 9.941f, 10.407f, 9.941f)
                curveTo(10.407f, 9.941f, 10.716f, 9.524f, 10.561f, 9.196f)
                curveTo(10.533f, 9.135f, 10.507f, 9.081f, 10.483f, 9.033f)
                curveTo(10.379f, 8.821f, 10.324f, 8.709f, 10.324f, 8.511f)
                curveTo(10.324f, 8.269f, 10.407f, 8.208f, 10.407f, 8.208f)
                horizontalLineTo(10.324f)
                curveTo(10.324f, 8.208f, 10.49f, 7.716f, 10.407f, 7.428f)
                curveTo(10.387f, 7.358f, 10.367f, 7.298f, 10.349f, 7.245f)
                curveTo(10.293f, 7.079f, 10.261f, 6.983f, 10.324f, 6.868f)
                curveTo(10.407f, 6.717f, 10.407f, 6.526f, 10.407f, 6.526f)
                lineTo(10.324f, 6.404f)
                verticalLineTo(6.258f)
                curveTo(10.324f, 6.208f, 10.34f, 6.197f, 10.358f, 6.185f)
                curveTo(10.381f, 6.169f, 10.407f, 6.151f, 10.407f, 6.045f)
                curveTo(10.407f, 5.963f, 10.466f, 5.923f, 10.52f, 5.887f)
                curveTo(10.562f, 5.859f, 10.6f, 5.834f, 10.604f, 5.792f)
                curveTo(10.733f, 5.989f, 11.005f, 6.322f, 11.233f, 6.258f)
                curveTo(11.592f, 6.159f, 10.925f, 5.519f, 10.925f, 5.519f)
                curveTo(10.925f, 5.519f, 11.475f, 5.963f, 11.814f, 5.963f)
                curveTo(12.136f, 5.963f, 11.433f, 5.435f, 11.362f, 5.382f)
                curveTo(11.426f, 5.429f, 12.007f, 5.844f, 12.361f, 5.686f)
                curveTo(12.532f, 5.61f, 12.48f, 5.515f, 12.373f, 5.434f)
                curveTo(12.518f, 5.477f, 12.687f, 5.485f, 12.836f, 5.378f)
                curveTo(13.178f, 5.13f, 13.178f, 4.97f, 13.178f, 4.97f)
                close()
                moveTo(12.038f, 5.261f)
                curveTo(12.038f, 5.261f, 12.184f, 5.378f, 12.373f, 5.434f)
                curveTo(12.245f, 5.338f, 12.038f, 5.261f, 12.038f, 5.261f)
                close()
                moveTo(10.561f, 5.686f)
                curveTo(10.505f, 5.611f, 10.531f, 5.679f, 10.604f, 5.792f)
                curveTo(10.607f, 5.765f, 10.596f, 5.731f, 10.561f, 5.686f)
                close()
                moveTo(9.549f, 5.686f)
                curveTo(9.605f, 5.611f, 9.579f, 5.679f, 9.506f, 5.792f)
                curveTo(9.503f, 5.765f, 9.515f, 5.731f, 9.549f, 5.686f)
                close()
                moveTo(8.072f, 5.261f)
                curveTo(8.072f, 5.261f, 7.926f, 5.378f, 7.737f, 5.434f)
                curveTo(7.865f, 5.338f, 8.072f, 5.261f, 8.072f, 5.261f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.018f, 5.986f)
                curveTo(7.018f, 5.986f, 6.272f, 7.001f, 6.355f, 8.085f)
                curveTo(6.438f, 9.17f, 7.323f, 11.692f, 9.947f, 11.692f)
                curveTo(9.97f, 11.692f, 9.992f, 11.692f, 10.015f, 11.692f)
                curveTo(12.795f, 11.692f, 13.585f, 8.91f, 13.585f, 7.91f)
                curveTo(13.585f, 6.901f, 12.956f, 5.986f, 12.956f, 5.986f)
                curveTo(12.956f, 5.986f, 13.029f, 7.34f, 12.956f, 7.91f)
                curveTo(12.734f, 9.629f, 11.651f, 10.423f, 9.996f, 10.423f)
                curveTo(8.331f, 10.423f, 7.3f, 9.599f, 7.018f, 7.91f)
                curveTo(6.927f, 7.364f, 7.018f, 5.986f, 7.018f, 5.986f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFCF1225)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.666f, 12.345f)
                curveTo(5.666f, 12.345f, 5.801f, 11.957f, 5.968f, 11.957f)
                curveTo(6.134f, 11.957f, 5.649f, 11.62f, 5.968f, 11.525f)
                curveTo(6.286f, 11.43f, 6.776f, 11.904f, 6.776f, 11.43f)
                curveTo(6.776f, 10.955f, 6.362f, 10.696f, 6.666f, 10.696f)
                curveTo(6.971f, 10.696f, 7.289f, 10.605f, 7.289f, 10.605f)
                curveTo(7.289f, 10.605f, 8.584f, 11.957f, 9.882f, 11.957f)
                curveTo(11.179f, 11.957f, 12.739f, 10.696f, 12.739f, 10.696f)
                curveTo(12.739f, 10.696f, 13.314f, 10.55f, 13.314f, 10.778f)
                curveTo(13.314f, 11.006f, 13.188f, 11.35f, 13.188f, 11.35f)
                curveTo(13.188f, 11.35f, 13.59f, 11.271f, 13.795f, 11.35f)
                curveTo(14f, 11.43f, 13.795f, 11.81f, 13.795f, 11.81f)
                verticalLineTo(11.957f)
                curveTo(13.795f, 11.957f, 14.329f, 11.839f, 14.329f, 12.05f)
                curveTo(14.329f, 12.26f, 14.071f, 12.14f, 13.55f, 12.2f)
                curveTo(13.028f, 12.26f, 12.83f, 12.667f, 12.502f, 12.667f)
                curveTo(12.175f, 12.667f, 12.104f, 12.345f, 12.104f, 12.345f)
                curveTo(12.104f, 12.345f, 11.088f, 12.895f, 9.882f, 12.895f)
                curveTo(8.675f, 12.895f, 7.946f, 12.345f, 7.946f, 12.345f)
                curveTo(7.946f, 12.345f, 8.06f, 12.91f, 7.674f, 12.789f)
                curveTo(7.289f, 12.667f, 6.894f, 11.899f, 6.431f, 12.05f)
                curveTo(5.968f, 12.2f, 5.666f, 12.345f, 5.666f, 12.345f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6E017)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.539f, 10.103f)
                curveTo(7.561f, 10.082f, 7.584f, 10.058f, 7.614f, 10.026f)
                curveTo(7.7f, 9.933f, 7.723f, 9.909f, 7.74f, 9.897f)
                curveTo(7.743f, 9.913f, 7.746f, 9.939f, 7.746f, 9.975f)
                curveTo(7.746f, 10.21f, 7.754f, 10.387f, 7.777f, 10.511f)
                curveTo(7.793f, 10.599f, 7.816f, 10.656f, 7.856f, 10.683f)
                curveTo(7.915f, 10.723f, 7.974f, 10.688f, 8.028f, 10.606f)
                curveTo(8.154f, 10.418f, 8.389f, 10.395f, 8.389f, 10.467f)
                curveTo(8.389f, 10.485f, 8.382f, 10.505f, 8.336f, 10.617f)
                curveTo(8.328f, 10.637f, 8.322f, 10.652f, 8.316f, 10.668f)
                curveTo(8.284f, 10.752f, 8.27f, 10.813f, 8.277f, 10.867f)
                curveTo(8.287f, 10.946f, 8.346f, 10.991f, 8.44f, 10.991f)
                curveTo(8.546f, 10.991f, 8.615f, 10.923f, 8.692f, 10.788f)
                curveTo(8.699f, 10.775f, 8.719f, 10.738f, 8.728f, 10.723f)
                lineTo(8.728f, 10.723f)
                lineTo(8.728f, 10.723f)
                lineTo(8.732f, 10.716f)
                curveTo(8.746f, 10.691f, 8.756f, 10.674f, 8.765f, 10.661f)
                curveTo(8.793f, 10.622f, 8.799f, 10.625f, 8.861f, 10.771f)
                curveTo(8.878f, 10.81f, 8.911f, 10.891f, 8.94f, 10.961f)
                lineTo(8.94f, 10.961f)
                curveTo(8.963f, 11.017f, 8.983f, 11.065f, 8.99f, 11.081f)
                curveTo(9.03f, 11.176f, 9.059f, 11.233f, 9.089f, 11.272f)
                curveTo(9.158f, 11.363f, 9.24f, 11.362f, 9.338f, 11.278f)
                curveTo(9.357f, 11.261f, 9.379f, 11.245f, 9.404f, 11.228f)
                curveTo(9.417f, 11.219f, 9.448f, 11.199f, 9.478f, 11.179f)
                lineTo(9.478f, 11.179f)
                lineTo(9.478f, 11.179f)
                lineTo(9.478f, 11.179f)
                curveTo(9.506f, 11.161f, 9.533f, 11.144f, 9.543f, 11.137f)
                curveTo(9.6f, 11.098f, 9.628f, 11.066f, 9.627f, 11.02f)
                curveTo(9.627f, 10.962f, 9.578f, 10.925f, 9.48f, 10.889f)
                curveTo(9.461f, 10.882f, 9.446f, 10.875f, 9.435f, 10.87f)
                lineTo(9.435f, 10.87f)
                lineTo(9.435f, 10.87f)
                curveTo(9.427f, 10.866f, 9.422f, 10.864f, 9.418f, 10.863f)
                curveTo(9.42f, 10.862f, 9.424f, 10.86f, 9.43f, 10.858f)
                lineTo(9.434f, 10.855f)
                curveTo(9.495f, 10.825f, 9.619f, 10.803f, 9.729f, 10.803f)
                lineTo(9.729f, 10.803f)
                curveTo(9.734f, 10.803f, 9.737f, 10.803f, 9.739f, 10.804f)
                curveTo(9.742f, 10.807f, 9.742f, 10.812f, 9.742f, 10.826f)
                verticalLineTo(10.826f)
                lineTo(9.742f, 10.828f)
                curveTo(9.741f, 10.861f, 9.734f, 10.893f, 9.706f, 10.995f)
                lineTo(9.697f, 11.031f)
                curveTo(9.666f, 11.15f, 9.658f, 11.222f, 9.679f, 11.285f)
                curveTo(9.71f, 11.376f, 9.798f, 11.408f, 9.935f, 11.381f)
                curveTo(10.12f, 11.344f, 10.21f, 11.271f, 10.234f, 11.158f)
                curveTo(10.24f, 11.13f, 10.241f, 11.108f, 10.241f, 11.064f)
                curveTo(10.241f, 10.991f, 10.241f, 10.991f, 10.304f, 10.991f)
                curveTo(10.392f, 10.991f, 10.427f, 11.022f, 10.464f, 11.109f)
                lineTo(10.477f, 11.141f)
                curveTo(10.52f, 11.245f, 10.56f, 11.29f, 10.651f, 11.29f)
                curveTo(10.711f, 11.29f, 10.753f, 11.265f, 10.745f, 11.206f)
                curveTo(10.744f, 11.191f, 10.739f, 11.178f, 10.729f, 11.16f)
                lineTo(10.722f, 11.146f)
                lineTo(10.709f, 11.12f)
                curveTo(10.653f, 11.006f, 10.675f, 10.918f, 10.868f, 10.795f)
                curveTo(10.923f, 10.759f, 11.008f, 10.7f, 11.082f, 10.648f)
                curveTo(11.135f, 10.611f, 11.182f, 10.578f, 11.208f, 10.561f)
                curveTo(11.21f, 10.577f, 11.212f, 10.598f, 11.213f, 10.63f)
                lineTo(11.216f, 10.712f)
                lineTo(11.218f, 10.752f)
                curveTo(11.226f, 10.962f, 11.269f, 11.153f, 11.333f, 11.231f)
                curveTo(11.44f, 11.363f, 11.544f, 11.241f, 11.615f, 10.951f)
                curveTo(11.682f, 10.674f, 11.779f, 10.412f, 11.873f, 10.254f)
                curveTo(11.919f, 10.176f, 11.962f, 10.127f, 11.995f, 10.112f)
                curveTo(12.017f, 10.102f, 12.032f, 10.109f, 12.055f, 10.151f)
                curveTo(12.14f, 10.305f, 12.27f, 10.448f, 12.381f, 10.49f)
                curveTo(12.545f, 10.553f, 12.642f, 10.42f, 12.642f, 10.125f)
                curveTo(12.642f, 9.877f, 12.682f, 9.679f, 12.749f, 9.526f)
                curveTo(12.772f, 9.474f, 12.796f, 9.431f, 12.82f, 9.397f)
                curveTo(12.834f, 9.377f, 12.844f, 9.365f, 12.849f, 9.361f)
                lineTo(12.778f, 9.285f)
                curveTo(12.745f, 9.316f, 12.7f, 9.381f, 12.655f, 9.483f)
                curveTo(12.583f, 9.65f, 12.539f, 9.862f, 12.539f, 10.125f)
                curveTo(12.539f, 10.358f, 12.493f, 10.421f, 12.417f, 10.392f)
                curveTo(12.333f, 10.36f, 12.218f, 10.233f, 12.144f, 10.099f)
                curveTo(12.097f, 10.014f, 12.028f, 9.982f, 11.954f, 10.016f)
                curveTo(11.897f, 10.042f, 11.841f, 10.104f, 11.785f, 10.199f)
                curveTo(11.685f, 10.368f, 11.585f, 10.639f, 11.516f, 10.925f)
                curveTo(11.485f, 11.05f, 11.453f, 11.129f, 11.411f, 11.163f)
                curveTo(11.367f, 11.108f, 11.327f, 10.936f, 11.32f, 10.748f)
                lineTo(11.319f, 10.709f)
                lineTo(11.316f, 10.625f)
                curveTo(11.314f, 10.586f, 11.312f, 10.56f, 11.309f, 10.538f)
                curveTo(11.298f, 10.471f, 11.264f, 10.432f, 11.203f, 10.448f)
                curveTo(11.179f, 10.454f, 11.063f, 10.534f, 10.959f, 10.606f)
                lineTo(10.959f, 10.606f)
                curveTo(10.901f, 10.647f, 10.847f, 10.684f, 10.814f, 10.705f)
                curveTo(10.576f, 10.858f, 10.538f, 11.005f, 10.618f, 11.167f)
                lineTo(10.624f, 11.18f)
                curveTo(10.605f, 11.171f, 10.592f, 11.149f, 10.571f, 11.1f)
                lineTo(10.558f, 11.067f)
                curveTo(10.506f, 10.946f, 10.439f, 10.886f, 10.304f, 10.886f)
                curveTo(10.173f, 10.886f, 10.139f, 10.94f, 10.139f, 11.064f)
                curveTo(10.139f, 11.101f, 10.138f, 11.117f, 10.134f, 11.136f)
                curveTo(10.12f, 11.203f, 10.064f, 11.248f, 9.916f, 11.278f)
                curveTo(9.823f, 11.296f, 9.787f, 11.283f, 9.776f, 11.25f)
                curveTo(9.764f, 11.215f, 9.771f, 11.156f, 9.796f, 11.057f)
                lineTo(9.805f, 11.023f)
                curveTo(9.835f, 10.91f, 9.843f, 10.876f, 9.844f, 10.83f)
                curveTo(9.846f, 10.751f, 9.807f, 10.698f, 9.729f, 10.698f)
                curveTo(9.604f, 10.698f, 9.467f, 10.722f, 9.39f, 10.76f)
                curveTo(9.264f, 10.823f, 9.289f, 10.929f, 9.446f, 10.988f)
                curveTo(9.476f, 10.999f, 9.497f, 11.009f, 9.509f, 11.015f)
                curveTo(9.518f, 11.019f, 9.523f, 11.021f, 9.524f, 11.021f)
                curveTo(9.523f, 11.021f, 9.52f, 11.023f, 9.515f, 11.027f)
                curveTo(9.509f, 11.033f, 9.499f, 11.041f, 9.485f, 11.051f)
                curveTo(9.477f, 11.056f, 9.454f, 11.071f, 9.428f, 11.088f)
                curveTo(9.397f, 11.108f, 9.362f, 11.13f, 9.347f, 11.14f)
                curveTo(9.319f, 11.159f, 9.295f, 11.178f, 9.272f, 11.197f)
                curveTo(9.215f, 11.246f, 9.199f, 11.246f, 9.169f, 11.207f)
                curveTo(9.146f, 11.177f, 9.121f, 11.127f, 9.083f, 11.039f)
                curveTo(9.077f, 11.024f, 9.057f, 10.976f, 9.035f, 10.921f)
                curveTo(9.006f, 10.851f, 8.972f, 10.769f, 8.955f, 10.729f)
                curveTo(8.867f, 10.521f, 8.772f, 10.474f, 8.683f, 10.598f)
                curveTo(8.671f, 10.616f, 8.658f, 10.635f, 8.643f, 10.664f)
                lineTo(8.638f, 10.672f)
                curveTo(8.629f, 10.689f, 8.61f, 10.723f, 8.603f, 10.735f)
                curveTo(8.544f, 10.839f, 8.497f, 10.886f, 8.44f, 10.886f)
                curveTo(8.394f, 10.886f, 8.381f, 10.876f, 8.378f, 10.853f)
                curveTo(8.374f, 10.823f, 8.386f, 10.774f, 8.412f, 10.706f)
                curveTo(8.417f, 10.691f, 8.423f, 10.677f, 8.431f, 10.658f)
                curveTo(8.488f, 10.518f, 8.492f, 10.507f, 8.492f, 10.467f)
                curveTo(8.492f, 10.253f, 8.114f, 10.291f, 7.944f, 10.547f)
                curveTo(7.929f, 10.569f, 7.917f, 10.583f, 7.908f, 10.59f)
                curveTo(7.899f, 10.576f, 7.887f, 10.542f, 7.878f, 10.491f)
                curveTo(7.856f, 10.376f, 7.848f, 10.203f, 7.848f, 9.975f)
                curveTo(7.848f, 9.83f, 7.805f, 9.753f, 7.711f, 9.795f)
                curveTo(7.669f, 9.814f, 7.667f, 9.815f, 7.54f, 9.953f)
                curveTo(7.512f, 9.984f, 7.49f, 10.006f, 7.47f, 10.025f)
                curveTo(7.443f, 10.05f, 7.42f, 10.067f, 7.401f, 10.078f)
                curveTo(7.371f, 10.093f, 7.36f, 10.084f, 7.345f, 10.016f)
                curveTo(7.328f, 9.946f, 7.323f, 9.847f, 7.323f, 9.681f)
                lineTo(7.323f, 9.612f)
                lineTo(7.323f, 9.541f)
                curveTo(7.323f, 9.424f, 7.292f, 9.358f, 7.216f, 9.358f)
                curveTo(7.189f, 9.358f, 7.163f, 9.367f, 7.13f, 9.384f)
                curveTo(7.118f, 9.39f, 7.106f, 9.397f, 7.09f, 9.406f)
                lineTo(7.048f, 9.43f)
                curveTo(6.978f, 9.47f, 6.931f, 9.488f, 6.887f, 9.488f)
                curveTo(6.879f, 9.488f, 6.874f, 9.49f, 6.872f, 9.49f)
                curveTo(6.871f, 9.491f, 6.87f, 9.491f, 6.87f, 9.491f)
                curveTo(6.87f, 9.49f, 6.871f, 9.49f, 6.871f, 9.489f)
                curveTo(6.873f, 9.487f, 6.878f, 9.481f, 6.884f, 9.47f)
                curveTo(6.913f, 9.413f, 6.991f, 9.32f, 7.117f, 9.197f)
                lineTo(7.046f, 9.121f)
                curveTo(6.913f, 9.252f, 6.829f, 9.351f, 6.793f, 9.421f)
                curveTo(6.743f, 9.518f, 6.782f, 9.594f, 6.887f, 9.594f)
                curveTo(6.953f, 9.594f, 7.013f, 9.57f, 7.098f, 9.522f)
                curveTo(7.196f, 9.466f, 7.201f, 9.463f, 7.216f, 9.463f)
                curveTo(7.216f, 9.463f, 7.221f, 9.475f, 7.221f, 9.541f)
                lineTo(7.221f, 9.612f)
                lineTo(7.221f, 9.681f)
                curveTo(7.22f, 9.855f, 7.226f, 9.959f, 7.245f, 10.04f)
                curveTo(7.274f, 10.165f, 7.345f, 10.226f, 7.447f, 10.171f)
                curveTo(7.476f, 10.156f, 7.506f, 10.133f, 7.539f, 10.103f)
                close()
                moveTo(7.751f, 9.891f)
                curveTo(7.752f, 9.891f, 7.752f, 9.891f, 7.752f, 9.891f)
                lineTo(7.751f, 9.891f)
                close()
                moveTo(9.415f, 10.858f)
                curveTo(9.413f, 10.856f, 9.412f, 10.856f, 9.412f, 10.856f)
                curveTo(9.413f, 10.86f, 9.414f, 10.863f, 9.416f, 10.864f)
                lineTo(9.415f, 10.858f)
                close()
                moveTo(11.228f, 10.549f)
                lineTo(11.227f, 10.55f)
                lineTo(11.228f, 10.55f)
                lineTo(11.228f, 10.549f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6E017)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.645f, 12.344f)
                curveTo(8.6f, 12.467f, 8.528f, 12.507f, 8.447f, 12.446f)
                curveTo(8.423f, 12.427f, 8.399f, 12.401f, 8.365f, 12.358f)
                lineTo(8.358f, 12.348f)
                lineTo(8.358f, 12.348f)
                curveTo(8.34f, 12.325f, 8.296f, 12.267f, 8.28f, 12.247f)
                curveTo(8.21f, 12.16f, 8.15f, 12.105f, 8.085f, 12.077f)
                lineTo(8.079f, 12.075f)
                lineTo(8.079f, 12.075f)
                curveTo(7.999f, 12.041f, 7.982f, 12.034f, 7.965f, 12.026f)
                lineTo(7.947f, 12.017f)
                curveTo(7.851f, 11.97f, 7.796f, 11.922f, 7.744f, 11.831f)
                curveTo(7.703f, 11.76f, 7.663f, 11.664f, 7.595f, 11.479f)
                lineTo(7.691f, 11.442f)
                curveTo(7.757f, 11.622f, 7.795f, 11.714f, 7.832f, 11.777f)
                curveTo(7.873f, 11.849f, 7.912f, 11.884f, 7.991f, 11.922f)
                lineTo(8.007f, 11.93f)
                curveTo(8.023f, 11.937f, 8.039f, 11.944f, 8.118f, 11.978f)
                lineTo(8.118f, 11.978f)
                lineTo(8.118f, 11.978f)
                lineTo(8.124f, 11.98f)
                curveTo(8.208f, 12.016f, 8.279f, 12.081f, 8.359f, 12.18f)
                curveTo(8.377f, 12.202f, 8.424f, 12.264f, 8.44f, 12.285f)
                lineTo(8.44f, 12.285f)
                lineTo(8.445f, 12.292f)
                curveTo(8.473f, 12.328f, 8.493f, 12.35f, 8.508f, 12.361f)
                curveTo(8.516f, 12.368f, 8.517f, 12.368f, 8.516f, 12.369f)
                curveTo(8.523f, 12.364f, 8.536f, 12.345f, 8.55f, 12.307f)
                curveTo(8.581f, 12.222f, 8.553f, 12.156f, 8.477f, 12.088f)
                curveTo(8.474f, 12.085f, 8.466f, 12.079f, 8.456f, 12.071f)
                lineTo(8.456f, 12.071f)
                curveTo(8.427f, 12.047f, 8.378f, 12.008f, 8.369f, 11.995f)
                curveTo(8.34f, 11.951f, 8.365f, 11.907f, 8.41f, 11.895f)
                curveTo(8.43f, 11.89f, 8.46f, 11.888f, 8.507f, 11.888f)
                curveTo(8.673f, 11.888f, 8.718f, 11.985f, 8.749f, 12.234f)
                lineTo(8.75f, 12.238f)
                curveTo(8.774f, 12.434f, 8.798f, 12.487f, 8.882f, 12.487f)
                curveTo(8.976f, 12.487f, 9.034f, 12.45f, 9.134f, 12.343f)
                lineTo(9.156f, 12.319f)
                curveTo(9.284f, 12.183f, 9.373f, 12.137f, 9.524f, 12.179f)
                curveTo(9.644f, 12.212f, 9.695f, 12.271f, 9.707f, 12.363f)
                curveTo(9.708f, 12.373f, 9.709f, 12.38f, 9.71f, 12.398f)
                curveTo(9.716f, 12.475f, 9.73f, 12.487f, 9.879f, 12.487f)
                curveTo(9.993f, 12.487f, 10.098f, 12.493f, 10.236f, 12.505f)
                lineTo(10.252f, 12.507f)
                lineTo(10.252f, 12.507f)
                curveTo(10.284f, 12.51f, 10.353f, 12.516f, 10.374f, 12.518f)
                curveTo(10.418f, 12.522f, 10.45f, 12.523f, 10.475f, 12.523f)
                curveTo(10.493f, 12.523f, 10.507f, 12.522f, 10.516f, 12.521f)
                curveTo(10.52f, 12.491f, 10.538f, 12.469f, 10.61f, 12.388f)
                curveTo(10.618f, 12.379f, 10.625f, 12.371f, 10.63f, 12.364f)
                curveTo(10.664f, 12.325f, 10.679f, 12.298f, 10.678f, 12.294f)
                curveTo(10.678f, 12.293f, 10.648f, 12.282f, 10.567f, 12.282f)
                curveTo(10.492f, 12.282f, 10.455f, 12.273f, 10.448f, 12.221f)
                curveTo(10.443f, 12.177f, 10.468f, 12.155f, 10.524f, 12.125f)
                curveTo(10.589f, 12.091f, 10.706f, 12.047f, 10.847f, 12.002f)
                curveTo(10.983f, 11.959f, 11.126f, 11.92f, 11.235f, 11.897f)
                curveTo(11.294f, 11.884f, 11.342f, 11.877f, 11.377f, 11.875f)
                curveTo(11.443f, 11.871f, 11.483f, 11.88f, 11.483f, 11.94f)
                curveTo(11.483f, 11.965f, 11.553f, 12.051f, 11.623f, 12.09f)
                curveTo(11.707f, 12.137f, 11.767f, 12.119f, 11.808f, 12.01f)
                curveTo(11.868f, 11.85f, 11.993f, 11.678f, 12.114f, 11.579f)
                curveTo(12.179f, 11.526f, 12.24f, 11.498f, 12.292f, 11.502f)
                curveTo(12.362f, 11.509f, 12.398f, 11.569f, 12.398f, 11.66f)
                horizontalLineTo(12.296f)
                curveTo(12.296f, 11.617f, 12.29f, 11.608f, 12.283f, 11.607f)
                curveTo(12.263f, 11.606f, 12.224f, 11.624f, 12.178f, 11.662f)
                curveTo(12.07f, 11.749f, 11.957f, 11.906f, 11.903f, 12.048f)
                curveTo(11.839f, 12.22f, 11.71f, 12.258f, 11.575f, 12.183f)
                curveTo(11.492f, 12.137f, 11.412f, 12.049f, 11.388f, 11.98f)
                curveTo(11.354f, 11.982f, 11.31f, 11.988f, 11.255f, 12f)
                curveTo(11.15f, 12.022f, 11.01f, 12.06f, 10.877f, 12.102f)
                curveTo(10.79f, 12.13f, 10.711f, 12.158f, 10.651f, 12.182f)
                curveTo(10.725f, 12.193f, 10.767f, 12.22f, 10.778f, 12.271f)
                curveTo(10.789f, 12.322f, 10.764f, 12.367f, 10.708f, 12.433f)
                curveTo(10.701f, 12.441f, 10.694f, 12.449f, 10.686f, 12.459f)
                curveTo(10.636f, 12.515f, 10.618f, 12.539f, 10.618f, 12.54f)
                curveTo(10.618f, 12.609f, 10.565f, 12.628f, 10.475f, 12.628f)
                curveTo(10.447f, 12.628f, 10.413f, 12.627f, 10.365f, 12.623f)
                curveTo(10.344f, 12.621f, 10.274f, 12.615f, 10.243f, 12.612f)
                lineTo(10.227f, 12.61f)
                curveTo(10.092f, 12.598f, 9.989f, 12.592f, 9.879f, 12.592f)
                curveTo(9.677f, 12.592f, 9.618f, 12.539f, 9.608f, 12.406f)
                curveTo(9.607f, 12.391f, 9.606f, 12.385f, 9.605f, 12.377f)
                curveTo(9.599f, 12.328f, 9.577f, 12.303f, 9.497f, 12.281f)
                curveTo(9.392f, 12.252f, 9.334f, 12.281f, 9.23f, 12.392f)
                lineTo(9.208f, 12.415f)
                curveTo(9.09f, 12.542f, 9.012f, 12.592f, 8.882f, 12.592f)
                curveTo(8.735f, 12.592f, 8.687f, 12.514f, 8.656f, 12.31f)
                curveTo(8.653f, 12.321f, 8.65f, 12.333f, 8.645f, 12.344f)
                close()
                moveTo(8.654f, 12.251f)
                lineTo(8.653f, 12.247f)
                curveTo(8.644f, 12.182f, 8.634f, 12.133f, 8.621f, 12.095f)
                curveTo(8.671f, 12.16f, 8.689f, 12.23f, 8.664f, 12.31f)
                curveTo(8.66f, 12.292f, 8.657f, 12.272f, 8.654f, 12.251f)
                close()
                moveTo(10.528f, 12.175f)
                lineTo(10.531f, 12.175f)
                lineTo(10.53f, 12.175f)
                lineTo(10.528f, 12.175f)
                close()
                moveTo(10.526f, 12.519f)
                lineTo(10.524f, 12.519f)
                lineTo(10.525f, 12.519f)
                lineTo(10.526f, 12.519f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BruneiPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Brunei,
            contentDescription = "Brunei Flag"
        )
    }
}
